import OSS from 'ali-oss'
import cacheKit from '@/utils/cacheKit'
import { Dialog,Toast} from 'vant';
import Axios from 'axios'
import Vue from 'vue'
import router from '@/router'

export default  {
    axios:null,
    /**
     * 获取axios
     */
    getAxios(){
        if(this.axios){
            return this.axios;
        }

        let tools = this;
        
        const axiosIns = Axios.create({
            baseURL: Vue.prototype.baseURL,
            timeout: 60000,
            withCredentials: true, // 跨域
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            }
        });

        /****** respone拦截器==>请求发出前处理 ******/
        axiosIns.interceptors.request.use(
            config => {
                //公司id
                var companyId = tools.getUrlParam("companyId");
                if(companyId){
                    config.headers.common['companyId'] = companyId;
                }
                //请求拦截(请求发出前处理请求;
                var token = cacheKit.get("token");
                if (token) {
                    // console.info("添加token")
                    config.headers.common['token'] = token;
                    config.headers.common['openid'] = tools.getUrlParam("openid");
                } else {
                    //没有token重新登录
                    // router.push("/login");
                    return config;
                }


                //当前平台:android ios
                let platform = Vue.prototype.$globalData.platform;
                console.info("platform",platform)

                if(platform){
                    config.headers.common['platform'] = platform;
                }

                return config;
            },
            error => {
                return Promise.error(error);
            }
        );

        //https://blog.csdn.net/qq_38145702/article/details/81558816
        /****** respone拦截器==>对响应做处理 ******/
        axiosIns.interceptors.response.use(
            response => {  //成功请求到数据
                //这里根据后端提供的数据进行对应的处理
                // console.info("response",response)
                if (response.data.code !== -4499) {
                    return response.data;
                } else {
                    Toast("登录过期，请重新登录");
                    cacheKit.remove("token");
                    cacheKit.remove("userInfo");
                    router.push("/login");
                    return response.data;
                }
            },
            error => {  //响应错误处理
                console.log('error');
                console.log(error);
                console.log(JSON.stringify(error));

                let text ='网络异常，请重试';
                Toast(text);

                return Promise.reject(error)
            }
        );
        
        this.axios = axiosIns;
        return axiosIns;
    },
    /**
     * 判断字符串是否为空
     * @param str
     * @returns {boolean}
     */
    isNull(str) {
        return str == null || str.length === 0 || str === '';
    },

    /**
     *
     * @desc  判断是否为身份证号
     * @param  {String|Number} str
     * @return {Boolean}
     */
    isIdCard(str) {
        return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(str)
    },

    /**
     *
     * @desc   判断是否为手机号
     * @param  {String|Number} str
     * @return {Boolean}
     */
    isPhoneNum(str) {
        return /^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/.test(str)
    },

    /**
     * 上传图片
     * @param {*} file 上传到图片
     * @param {*} callback(url,time) 回调方法
     */
    uploadFile(file,callback){
        var userInfo = cacheKit.get("userInfo");
        if(!userInfo){
           alert("请先登录！")
           return;
        }
        
        if(file.size>1024*1024*2){
            alert("图片大小不能大于2M")
            return;
        }

        const client = new OSS({
            region: 'oss-cn-beijing',
            accessKeyId: 'LTAIygxT5XV8CNcN',
            accessKeySecret: '0Blct0QNK8smIGUFLAZLusoYAwZCep',
            bucket: 'td-server'
          });
        
        var timestamp = Date.parse(new Date());
        var radomName = "img/"+userInfo.id+"_"+userInfo.phone+"_"+timestamp+"."+file.name.split('.').pop();
        
        client
            .multipartUpload(radomName,file)
            .then(function(result){
                console.log(result);
                if(callback){
                  callback('https://td-server.oss-cn-beijing.aliyuncs.com/'+radomName)
                }
            });
    },
    /**
     * 同步上传文件 (调用方法请使用)
     * @param {*} file 要上传的文件 async和await （  async function 调用方法{ var url =await uploadFileSync(file) { ... }  } ）
     */
     uploadFileSync(file){
        var uploadFile =this.uploadFile;
        
        var uploadFileFun = function(){
            return new Promise(function(resolve){
                uploadFile(file,function(url){
                    resolve(url);
                });
            });
        }

        return  uploadFileFun();
    },
    
    /**
     * 获取用户当前位置
     */
    loadLocation(){
            let address = cacheKit.get("address");
            if(!address){
                AMap.plugin('AMap.Geolocation', function() {
                    var geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,//是否使用高精度定位，默认:true
                        timeout: 10000,          //超过10秒后停止定位，默认：5s
                        buttonPosition:'RB',    //定位按钮的停靠位置
                        buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                        zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
                });

                geolocation.getCurrentPosition(function(status,result){
                        // console.info("result",result)
                        if(status=='complete'){
                            Toast("当前位置"+result.formattedAddress);
                             address = {
                                gaodeLongitude:result.position.lng,
                                gaodeLatitude:result.position.lat,
                                province: result.addressComponent.province,
                                city: result.addressComponent.city,
                                area: result.addressComponent.district,
                            };
                            //保存用户位置
                            getUserAddress(address);
                            cacheKit.set("address",address,3600*24*30);
                            
                        }else{
                            // Dialog.alert({
                            //     message: '需要通过定位来获取你周边的人哦'
                            // }).then(() => {
                            //     location.reload();
                            // });
                        }
                    });
                });
            
            }
        },
        /**
         * 时间格式化
         * @param {*} date 
         * @param {*} format  "yyyy-MM-dd hh:mm:ss"
         */
  dateFormat(date,fmt){
        var o = { 
           "M+" : date.getMonth()+1,                 //月份 
           "d+" : date.getDate(),                    //日 
           "h+" : date.getHours(),                   //小时 
           "m+" : date.getMinutes(),                 //分 
           "s+" : date.getSeconds(),                 //秒 
           "q+" : Math.floor((date.getMonth()+3)/3), //季度 
           "S"  : date.getMilliseconds()             //毫秒 
       }; 
       if(/(y+)/.test(fmt)) {
               fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
       }
        for(var k in o) {
           if(new RegExp("("+ k +")").test(fmt)){
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
            }
        }
       return fmt; 
  },
  getUrlParam: function (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
},
/**
 * 时间格式化
 * @param {*} timestamp 
 */
time(timestamp){
   return this.dateFormat(timestamp,"yyyy-MM-dd hh:mm:ss");
},
/**
 * 刷新页面
 */
reload(){
    let timestamp =  (new Date()).getTime();
    let href = window.location.href;
    let url = href.split('#')[0];
    let router = href.split('#')[1];
        
    if(url.indexOf("?")==-1){
        window.location.href = (url+"?timestamp_1="+timestamp)+"#"+router;
    }else{
        window.location.href = (url+"&timestamp_1="+timestamp)+"#"+router;
    }
    
    // window.location.reload(true); 
},
/**
 * 判断是否微信浏览器
 */
isWechat(){
    var ua = navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i)=="micromessenger") {
    return true;
    } 
    return false    
    },
    /**
     * 检查用户信息是否完整
     */
 checkUserInfo(){
    let userInfo = cacheKit.get("userInfo");
    console.info("userInfo--》",userInfo)
    console.info("checkUserInfo",(userInfo.img1 && userInfo.name && userInfo.cityId && userInfo.job && userInfo.birthday && userInfo.sex))
    return (userInfo.img1 && userInfo.name && userInfo.cityId && userInfo.job && userInfo.birthday && userInfo.sex);
 },
    /**
     * 检查是否单身
     */
    checkIsSingle(){
        let userInfo = cacheKit.get("userInfo");
        console.info("userInfo--》",userInfo)
        return userInfo.singleStatus==0;
     },
     /**
      * 更新用户信息（本地缓存）
      */
     updateUserInfoCache(){
        this.getAxios().post('/api/v1/user/getMyUserInfo',null)
        .then(resp => {
       if(resp.code==0){
           let userInfo = resp.data;
           cacheKit.set("userInfo",userInfo,3600*24*7);
       }
    });
     }
}


// WEBPACK FOOTER //
// ./src/utils/tools.js